<template>
  <div
    class="flex flex-col items-center justify-center py-3 gap-3 bg-white border-b border-secondary"
    :class="{
      'h-14': !withSearch,
      'h-26': withSearch,
      'px-4': viewport !== 'desktop',
      'px-5': viewport === 'desktop',
      'md:px-5': viewport === 'reactive',
    }"
  >
    <div class="w-full flex items-center justify-between shrink-0 grow gap-2">
      <div class="flex items-center grow gap-2">
        <Transition name="fade-slow" mode="out-in">
          <IconButton
            v-if="showBack"
            variant="tertiary"
            type="gray"
            :size="isMobile ? 'lg' : 'xs'"
            @click="$emit('back')"
          >
            <Icon name="chevron-left" />
          </IconButton>
        </Transition>
        <span
          class="text-primary font-medium"
          :class="{
            'text-style-xl': viewport !== 'desktop',
            'text-style-lg': viewport === 'desktop',
            'md:text-style-lg': viewport === 'reactive',
          }"
        >
          <slot>
            {{ title }}
          </slot>
        </span>
        <Badge
          v-if="count"
          :label="count"
          variant="pill"
          type="color"
          :size="isMobile ? 'md' : 'sm'"
          :number="true"
        />
      </div>
      <slot name="button" :isMobile="isMobile" />
    </div>
    <div v-if="withSearch" class="w-full">
      <slot name="search" :query="query.trim().toLowerCase()">
        <DialogSearch v-model="query" />
      </slot>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { IconButton } from "@/SharedComponents/Buttons";
import { Badge } from "@/SharedComponents/Badges";
import { DialogSearch } from "@/SharedComponents/Dialog";
import { Icon } from "@/SharedComponents/Icon";
import { useBreakpoints } from "@/Composables/useBreakpoints";

defineEmits(["back"]);

const props = defineProps({
  title: { type: String, required: false },
  count: { type: [String, Number], required: false },
  showBack: { type: Boolean, default: true },
  withSearch: { type: Boolean, default: false },
  viewport: {
    type: String,
    validator: (val) => ["mobile", "desktop", "reactive"].includes(val),
    default: "reactive",
  },
});

const query = ref("");

function clearQuery() {
  query.value = "";
}

const { maxTablet } = useBreakpoints();

const isMobile = computed(() => {
  switch (props.viewport) {
    case "mobile":
      return true;
    case "desktop":
      return false;
    case "reactive":
    default:
      return maxTablet.value;
  }
});

defineExpose({
  query: computed(() => query.value.trim().toLowerCase()),
  clearQuery,
});
</script>
